<div class="agents">
  <div class="agents__header">
    <img class="icon" src="/assets/images/collar@2x.png" alt="Agent icon" />
    <div class="title">Your agent will help</div>
  </div>
  @if (agents && agents.length > 0) {
    @for (agent of agents; track agent.agentId; let i = $index) {
      <amfam-profile-card
        [index]="i"
        [id]="agent.agentId"
        [url]="agent.url"
        [name]="agent.name"
        [office]="agent.office"
        [recommended]="agent.recommended"
        [address]="agent.address"
        [selected]="agent.agentId === selectedAgent?.agentId && agents.length > 1"
        [showRadio]="agents.length > 1"
        [hover]="agents.length > 1"
        (profileSelected)="onAgentSelected(agent)"
      >
      </amfam-profile-card>
    }
  }

  <div class="agents__actions">
    <call-to-action
      [primaryButtonName]="primaryButtonName"
      [secondaryButtonName]="secondaryButtonName"
      [capitalize]="true"
      (primaryEvent)="sendToAgent.emit(selectedAgent)"
      (secondaryEvent)="cancel.emit()"
      [disablePrimaryButton]="!this.selectedAgent"
    >
    </call-to-action>
  </div>
</div>
